import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { User, ResetPasswordDto } from '@app/core/models';
import { environment } from 'src/environments/environment';
import { map, share } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class UserService extends BaseService {
  constructor(protected http: HttpClient) {
    super('users', http);
  }

  public getCurrentUserDetails(): Observable<User> {
    return this.http
      .get<User>(`${environment.apiUrl}auth/session`)
      .pipe(share());
  }

  public resetPassword(
    resetPasswordDto: ResetPasswordDto
  ): Observable<boolean> {
    return this.http
      .post<{ success: boolean }>(
        `${this.resourceUrl}/${resetPasswordDto.userId}/reset-password`,
        {
          adminPassword: resetPasswordDto.adminPassword,
          newPassword: resetPasswordDto.newPassword,
        }
      )
      .pipe(map((response) => response.success));
  }

  // Self-service: change the signed-in user's own password.
  public changePassword(
    currentPassword: string,
    newPassword: string
  ): Observable<boolean> {
    return this.http
      .post<{ success: boolean }>(`${this.resourceUrl}/change-password`, {
        currentPassword,
        newPassword,
      })
      .pipe(map((response) => response.success));
  }
}
